module.exports = __webpack_public_path__ + "static/media/old-republic.8fa4c92f.svg";